import Axios from "axios";
import {getUploadUrl} from "../../../../utils/baseUrl";

export const handleDownloadDevis = (id) => {
    Axios({
        method: "get",
        url: `${getUploadUrl()}/devis/${id}.pdf`,
        responseType: "arraybuffer"
    })
        .then((response) => {
            var link = document.createElement("a");

            if (window["ReactNativeWebView"]) {
                link.href = response.config.url;
            } else {
                link.href = window.URL.createObjectURL(
                    new Blob([response.data], {type: "application/octet-stream"})
                );
            }

            link.download = `${id}.pdf`;

            document.body.appendChild(link);

            link.click();
            // setTimeout(function () {
            // 	window.URL.revokeObjectURL(link);
            // }, 200);
        });
};